import React, { Component, Fragment } from 'react'
import Img from 'react-image'
import VisibilitySensor from 'react-visibility-sensor'
import helpers from '../../helpers'
import { HOOK_URL } from '../../constants'

import placeholder from '../../assets/productplaceholder.png'

import { Product, Meta, ImageContainer, Title, Inputs, InputContainer, OrderCount, TitleContainer, Price } from './styles'

import OrderInput from '../OrderInput/'
import Loader from '../Loader/'

class Order extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: false,
      overlayActive: false
    }
  }

  deleteClick(e) {
    this.props.deleteFromOrder(this.props.product.id)
  }

  onChange(isVisible) {
    if (!this.state.isVisible) {
      this.setState({ isVisible })
    }
  }

  render() {
    const { product, order, wholeOrder, noAmount, small, priceAgreements, viewPrices } = this.props
    try {
      product.thumbnail = require(`../../assets/products/images/${product.productCode}/1.jpg`)
    } catch (e) {
      product.thumbnail = placeholder
    }
    // Get the current orderpart
    let currentOrder = this.props.wholeOrder
    const index = currentOrder.orderParts.findIndex(orderPart => orderPart.product.id === this.props.product.id)
    const orderPart = currentOrder.orderParts[index]

    
    // Search for priceAgreements with the same product, sort by priority and take the last one
    const priceAgreementsProduct = priceAgreements && orderPart ? priceAgreements.filter(priceAgreement => priceAgreement.productCode === orderPart.product.productCode) : false
    const priceAgreementSorted = priceAgreementsProduct.length > 0 ? priceAgreementsProduct.sort((a, b) => a.priority - b.priority)
    .filter((item, index, array) => item.priority === array[0].priority) : false
    const priceAgreement = priceAgreementSorted.length > 0 ? priceAgreementSorted[0] : false
    // Favor a price agreement for a product over a category
    const hookUrl = window.sessionStorage.getItem(HOOK_URL)
    const price = orderPart ?  priceAgreement ? priceAgreement.percentage ? orderPart.product.price * ((100 - priceAgreement.percentage) / 100) : priceAgreement.price : orderPart.product.price : false
    
    return (
      <Product small={small} key={product.id} noAmount={noAmount}>
        <Meta>
          <VisibilitySensor onChange={this.onChange.bind(this)}>
            <ImageContainer>
              {this.state.isVisible ? (
                <Img
                  src={product.thumbnail}
                  loader={<Loader from="0%" to="100%" />}
                  unloader={<img alt="product" src={placeholder} />}
                />
              ) : (
                <div />
              )}
            </ImageContainer>
          </VisibilitySensor>
          <TitleContainer>
            <Title dangerouslySetInnerHTML={{ __html: product.firstDescription }} />
            {(price && hookUrl && viewPrices) || (price && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue && viewPrices) ? (
              <Price>€ {Number(price).toFixed(2).replace('.', ',')} per {helpers.translateUnits(product.unit).singular}</Price>
            ) : null}
          </TitleContainer>
          
          
        </Meta>
        <Inputs>
          {this.props.editOrder ? (
            <Fragment>
              <InputContainer>
                <OrderInput
                  orderPart={orderPart}
                  product={product}
                  order={order}
                  wholeOrder={wholeOrder}
                  orderId={this.props.orderId}
                  type={'orderList'}
                />
              </InputContainer>
            </Fragment>
          ) : (
            <OrderCount>{order} st.</OrderCount>
          )}
        </Inputs>
      </Product>
    )
  }
}

export default Order



// WEBPACK FOOTER //
// ./src/components/Order/index.js